import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import SelectRide from "./pages/SelectRide";
import BookDelivery from "./pages/BookDelivery";
import DeliveryHistory from "./pages/DeliveryHistory";
import RideTracking from "./pages/RideTracking";
import RateRide from "./pages/RateRide";
import RideHistory from "./pages/RideHistory";
import ScheduledRides from "./pages/ScheduledRides";
import Auth from "./pages/Auth";
import Profile from "./pages/Profile";
import ActiveSessions from "./pages/profile/ActiveSessions";
import Drive from "./pages/Drive";
import Business from "./pages/Business";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminUsers from "./pages/admin/AdminUsers";
import AdminDrivers from "./pages/admin/AdminDrivers";
import AdminBikers from "./pages/admin/AdminBikers";
import AdminRides from "./pages/admin/AdminRides";
import AdminAnalytics from "./pages/admin/AdminAnalytics";
import AdminSettings from "./pages/admin/AdminSettings";
import AdminPricing from "./pages/admin/AdminPricing";
import AdminWalletManagement from "./pages/admin/AdminWalletManagement";
import AdminMonitoring from "./pages/admin/AdminMonitoring";
import DriverLogin from "./pages/driver/DriverLogin";
import DriverApplication from "./pages/driver/DriverApplication";
import DriverDashboard from "./pages/driver/DriverDashboard";
import DriverRides from "./pages/driver/DriverRides";
import DriverHistory from "./pages/driver/DriverHistory";
import DriverWallet from "./pages/driver/DriverWallet";
import DriverAnalytics from "./pages/driver/DriverAnalytics";
import DriverReviews from "./pages/driver/DriverReviews";
import ActiveRide from "./pages/driver/ActiveRide";
import BikerLogin from "./pages/biker/BikerLogin";
import BikerApplication from "./pages/biker/BikerApplication";
import BikerDashboard from "./pages/biker/BikerDashboard";
import BikerDeliveries from "./pages/biker/BikerDeliveries";
import BikerRides from "./pages/biker/BikerRides";
import BikerActiveRide from "./pages/biker/BikerActiveRide";
import BikerHistory from "./pages/biker/BikerHistory";
import BikerWallet from "./pages/biker/BikerWallet";
import BikerAnalytics from "./pages/biker/BikerAnalytics";
import BikerReviews from "./pages/biker/BikerReviews";
import Reviews from "./pages/Reviews";
import LogisticsHome from "./pages/LogisticsHome";
import LogisticsBook from "./pages/LogisticsBook";
import LogisticsTrack from "./pages/LogisticsTrack";
import LogisticsMyShipments from "./pages/LogisticsMyShipments";
import OperatorLogin from "./pages/operator/OperatorLogin";
import OperatorApplication from "./pages/operator/OperatorApplication";
import OperatorDashboard from "./pages/operator/OperatorDashboard";
import OperatorActiveJob from "./pages/operator/OperatorActiveJob";
import OperatorPending from "./pages/operator/OperatorPending";
import OperatorEarnings from "./pages/operator/OperatorEarnings";
import AdminLogistics from "./pages/admin/AdminLogistics";
import AdminBusManagement from "./pages/admin/AdminBusManagement";
import AdminSeatMapEditor from "./pages/admin/AdminSeatMapEditor";
import BusSearch from "./pages/bus/BusSearch";
import BusSeatSelection from "./pages/bus/BusSeatSelection";
import BusCheckout from "./pages/bus/BusCheckout";
import BusMyTickets from "./pages/bus/BusMyTickets";
import BusOperatorLogin from "./pages/bus/BusOperatorLogin";
import BusOperatorApplication from "./pages/bus/BusOperatorApplication";
import BusOperatorDashboard from "./pages/bus/BusOperatorDashboard";
import BusOperatorFleet from "./pages/bus/BusOperatorFleet";
import BusOperatorRoutes from "./pages/bus/BusOperatorRoutes";
import BusOperatorSchedules from "./pages/bus/BusOperatorSchedules";
import BusOperatorBookings from "./pages/bus/BusOperatorBookings";
import BusOperatorWalkIn from "./pages/bus/BusOperatorWalkIn";
import BusPaymentSuccess from "./pages/bus/BusPaymentSuccess";
import BusReview from "./pages/bus/BusReview";
import BusTicketTransfer from "./pages/bus/BusTicketTransfer";
import BusTracking from "./pages/bus/BusTracking";
import BusOperatorScan from "./pages/bus/BusOperatorScan";
import BusOperatorManifest from "./pages/bus/BusOperatorManifest";
// Courier (DHL-style) pages
import CourierHome from "./pages/courier/CourierHome";
import CourierQuote from "./pages/courier/CourierQuote";
import CourierShip from "./pages/courier/CourierShip";
import CourierTrack from "./pages/courier/CourierTrack";
import CourierMyShipments from "./pages/courier/CourierMyShipments";
import CourierOps from "./pages/courier/CourierOps";
import AdminCourier from "./pages/admin/AdminCourier";
import BusMultiCityPlanner from "./pages/bus/BusMultiCityPlanner";
import SharedRideTrack from "./pages/SharedRideTrack";
import DriverEarnings from "./pages/driver/DriverEarnings";
import AdminSurgePricing from "./pages/admin/AdminSurgePricing";
import AdminPromos from "./pages/admin/AdminPromos";
import AdminWinback from "./pages/admin/AdminWinback";
import RecurringRides from "./pages/RecurringRides";
import PackageTracking from "./pages/PackageTracking";
import BookMultiDrop from "./pages/BookMultiDrop";
import MyMultiDrops from "./pages/MyMultiDrops";
import OperatorRevenue from "./pages/operator/OperatorRevenue";
import AdminSettlements from "./pages/admin/AdminSettlements";
import AdminOpsLive from "./pages/admin/AdminOpsLive";
import AdminWhatsApp from "./pages/admin/AdminWhatsApp";
import AdminWhatsAppAnalytics from "./pages/admin/AdminWhatsAppAnalytics";
import AdminBusRefunds from "./pages/admin/AdminBusRefunds";
import AdminBusReminders from "./pages/admin/AdminBusReminders";
import AdminPushBroadcast from "./pages/admin/AdminPushBroadcast";
import AdminCities from "./pages/admin/AdminCities";
import AdminCityWaitlist from "./pages/admin/AdminCityWaitlist";
import { Toaster } from "./components/ui/toaster";
import { LanguageProvider } from "./contexts/LanguageContext";

function App() {
  return (
    <LanguageProvider>
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Legal Pages (No Navbar) */}
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />

          {/* Public Trip Sharing (No Navbar, no auth) */}
          <Route path="/track/shared/:token" element={<SharedRideTrack />} />

          {/* Public Package Tracking (No Navbar, no auth) */}
          <Route path="/track/package/:token" element={<PackageTracking />} />
          
          {/* Admin Routes (No Navbar) */}
          <Route path="/admin" element={<Navigate to="/admin/login" replace />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/users" element={<AdminUsers />} />
          <Route path="/admin/drivers" element={<AdminDrivers />} />
          <Route path="/admin/bikers" element={<AdminBikers />} />
          <Route path="/admin/rides" element={<AdminRides />} />
          <Route path="/admin/analytics" element={<AdminAnalytics />} />
          <Route path="/admin/wallets" element={<AdminWalletManagement />} />
          <Route path="/admin/pricing" element={<AdminPricing />} />
          <Route path="/admin/surge" element={<AdminSurgePricing />} />
          <Route path="/admin/promos" element={<AdminPromos />} />
          <Route path="/admin/winback" element={<AdminWinback />} />
          <Route path="/admin/settlements" element={<AdminSettlements />} />
          <Route path="/admin/ops-live" element={<AdminOpsLive />} />
          <Route path="/admin/whatsapp" element={<AdminWhatsApp />} />
          <Route path="/admin/whatsapp/analytics" element={<AdminWhatsAppAnalytics />} />
          <Route path="/admin/bus-refunds" element={<AdminBusRefunds />} />
          <Route path="/admin/bus-reminders" element={<AdminBusReminders />} />
          <Route path="/admin/push-broadcast" element={<AdminPushBroadcast />} />
          <Route path="/admin/cities" element={<AdminCities />} />
          <Route path="/admin/city-waitlist" element={<AdminCityWaitlist />} />
          <Route path="/admin/settings" element={<AdminSettings />} />
          <Route path="/admin/monitoring" element={<AdminMonitoring />} />
          <Route path="/admin/logistics" element={<AdminLogistics />} />
          <Route path="/admin/bus" element={<AdminBusManagement />} />
          <Route path="/admin/bus/seat-map/:busId" element={<AdminSeatMapEditor />} />
          
          {/* Driver Routes (No Navbar) */}
          <Route path="/driver/login" element={<DriverLogin />} />
          <Route path="/driver/apply" element={<DriverApplication />} />
          <Route path="/driver/dashboard" element={<DriverDashboard />} />
          <Route path="/driver/rides" element={<DriverRides />} />
          <Route path="/driver/active-ride" element={<ActiveRide />} />
          <Route path="/driver/history" element={<DriverHistory />} />
          <Route path="/driver/wallet" element={<DriverWallet />} />
          <Route path="/driver/analytics" element={<DriverAnalytics />} />
          <Route path="/driver/reviews" element={<DriverReviews />} />
          <Route path="/driver/earnings" element={<DriverEarnings />} />
          
          {/* Biker Routes (No Navbar) */}
          <Route path="/biker/login" element={<BikerLogin />} />
          <Route path="/biker/apply" element={<BikerApplication />} />
          <Route path="/biker/dashboard" element={<BikerDashboard />} />
          <Route path="/biker/deliveries" element={<BikerDeliveries />} />
          <Route path="/biker/rides" element={<BikerRides />} />
          <Route path="/biker/active-ride" element={<BikerActiveRide />} />
          <Route path="/biker/history" element={<BikerHistory />} />
          <Route path="/biker/wallet" element={<BikerWallet />} />
          <Route path="/biker/analytics" element={<BikerAnalytics />} />
          <Route path="/biker/reviews" element={<BikerReviews />} />
          
          {/* Logistics Routes (No Navbar - has its own UI) */}
          <Route path="/logistics" element={<LogisticsHome />} />
          <Route path="/logistics/book" element={<LogisticsBook />} />
          <Route path="/logistics/track" element={<LogisticsTrack />} />
          <Route path="/logistics/track/:trackingCode" element={<LogisticsTrack />} />
          <Route path="/logistics/my-shipments" element={<LogisticsMyShipments />} />
          
          {/* Operator Routes (No Navbar - has its own UI) */}
          <Route path="/operator/login" element={<OperatorLogin />} />
          <Route path="/operator/apply" element={<OperatorApplication />} />
          <Route path="/operator/dashboard" element={<OperatorDashboard />} />
          <Route path="/operator/active-job" element={<OperatorActiveJob />} />
          <Route path="/operator/pending" element={<OperatorPending />} />
          <Route path="/operator/earnings" element={<OperatorEarnings />} />
          
          {/* Bus Booking Routes (No Navbar - has its own UI) */}
          <Route path="/bus" element={<BusSearch />} />
          <Route path="/bus/planner" element={<BusMultiCityPlanner />} />
          <Route path="/bus/seats" element={<BusSeatSelection />} />
          <Route path="/bus/checkout" element={<BusCheckout />} />
          <Route path="/bus/tickets" element={<BusMyTickets />} />
          <Route path="/bus/payment/success" element={<BusPaymentSuccess />} />
          <Route path="/bus/review/:bookingId" element={<BusReview />} />
          <Route path="/bus/transfer/:bookingId" element={<BusTicketTransfer />} />
          <Route path="/bus/track/:tripId" element={<BusTracking />} />
          <Route path="/bus/operator/login" element={<BusOperatorLogin />} />
          <Route path="/bus/operator/apply" element={<BusOperatorApplication />} />
          <Route path="/bus/operator" element={<BusOperatorDashboard />} />
          <Route path="/bus/operator/fleet" element={<BusOperatorFleet />} />
          <Route path="/bus/operator/routes" element={<BusOperatorRoutes />} />
          <Route path="/bus/operator/schedules" element={<BusOperatorSchedules />} />
          <Route path="/bus/operator/bookings" element={<BusOperatorBookings />} />
          <Route path="/bus/operator/walk-in" element={<BusOperatorWalkIn />} />
          <Route path="/bus/operator/scan" element={<BusOperatorScan />} />
          <Route path="/bus/operator/manifest" element={<BusOperatorManifest />} />

          {/* Courier Routes (No Navbar - has its own DHL-style UI) */}
          <Route path="/courier" element={<CourierHome />} />
          <Route path="/courier/quote" element={<CourierQuote />} />
          <Route path="/courier/ship" element={<CourierShip />} />
          <Route path="/courier/track" element={<CourierTrack />} />
          <Route path="/courier/track/:awb" element={<CourierTrack />} />
          <Route path="/courier/shipments" element={<CourierMyShipments />} />
          <Route path="/courier/ops" element={<CourierOps />} />
          <Route path="/admin/courier" element={<AdminCourier />} />
          
          {/* User Routes (With Navbar) */}
          <Route path="*" element={
            <>
              <Navbar />
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/select-ride" element={<SelectRide />} />
                <Route path="/book-delivery" element={<BookDelivery />} />
                <Route path="/deliveries" element={<DeliveryHistory />} />
                <Route path="/tracking" element={<RideTracking />} />
                <Route path="/rate-ride" element={<RateRide />} />
                <Route path="/rides" element={<RideHistory />} />
                <Route path="/scheduled-rides" element={<ScheduledRides />} />
                <Route path="/recurring-rides" element={<RecurringRides />} />
                <Route path="/multi-drop" element={<BookMultiDrop />} />
                <Route path="/multi-drop/mine" element={<MyMultiDrops />} />
                <Route path="/operator/revenue" element={<OperatorRevenue />} />
                <Route path="/reviews" element={<Reviews />} />
                <Route path="/login" element={<Auth mode="login" />} />
                <Route path="/signup" element={<Auth mode="signup" />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/profile/sessions" element={<ActiveSessions />} />
                <Route path="/drive" element={<Drive />} />
                <Route path="/business" element={<Business />} />
              </Routes>
            </>
          } />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </div>
    </LanguageProvider>
  );
}

export default App;
